






























































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TextInput } from '@/components';
import UploadTo from '@/components/Uploader.vue';
import { Button, Dialog, Toast, Popup, Picker, DatetimePicker } from 'vant';
import { FileType } from '@/common/ts/enum';
import { save } from '@/api/api';
import * as config from './config';
import { isWeiXin } from '@/common/ts/common';
import qs from 'qs';

Vue.use(Toast)
  .use(Popup)
  .use(Dialog)
  .use(Button)
  .use(Picker)
  .use(DatetimePicker);
@Component({
  components: {
    TextInput,
    UploadTo,
  },
})
export default class Upload extends Vue {
  options = config.OPTHINES;
  pointOut = false;
  noButton = true;
  FileType = FileType;
  coverArr: any[] = [];
  typeTitle = '重庆100佳民心医师';
  departmentText = '申报医师姓名';
  userNameText = '医师所属科室';
  coverText = '医师照片';
  honorsText = '主要荣誉';
  // 需要传的参数
  companyName?: string = ''; // 单位名称
  legalPerson?: string = ''; // 法人姓名
  department?: string = ''; // 申报医师姓名/申报科室
  userName?: string = ''; // 科室负责人/医师所属科室
  contactPerson?: string = ''; // 联络人
  honors?: string = ''; // 荣誉
  reasons?: string = ''; // 申报理由
  cover?: string = ''; // 照片
  get type() {
    return this.$route.query.type;
  }
  created() {
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    if (!window.udid) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行报名',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        overlay: true,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
    if (Number(this.$route.query.type) === 1) {
      this.departmentText = '申报科室';
      this.userNameText = '科室负责人';
      this.coverText = '科室照片';
      this.honorsText = '科室荣誉';
      this.typeTitle = '重庆100佳民心科室';
    }
    this.$appShareInfo({
      title: '健康民心“双百”口碑榜',
      url: window.location.href,
      subtitle: '第三届医师节千万网民点赞的“100佳民心医师和100佳民心科室”活动',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });

    this.$wxShareInfo({
      title: '健康民心“双百”口碑榜',
      subtitle: '第三届医师节千万网民点赞的“100佳民心医师和100佳民心科室”活动',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  enterSave() {
    if (!this.companyName) {
      Toast.fail('请输入单位名称');
      return false;
    }
    if (!this.legalPerson) {
      Toast.fail('请输入法人姓名');
      return false;
    }
    if (!this.department) {
      Toast.fail('请输入' + this.departmentText);
      return false;
    }
    if (!this.userName) {
      Toast.fail('请输入' + this.userNameText);
      return false;
    }
    if (!this.contactPerson) {
      Toast.fail('请输入联络人');
      return false;
    }
    if (!this.honors) {
      Toast.fail('请输入荣誉');
      return false;
    }

    if (!this.reasons) {
      Toast.fail('请输入申报理由');
      return false;
    }
    setTimeout(() => {
      this.enterSaveNext();
    }, 500);
  }
  async enterSaveNext() {
    // 上传截图
    await (this.$refs.uploaderImage as UploadTo)
      .uploadToOss()
      .then((res: any) => {
        console.log('img urls result:', '|' + (res as any).join('|'));
        this.cover = '|' + (res as any).join('|');
        this.coverArr = res;
      });
    if (this.coverArr.length < 4) {
      Toast.fail('请上传4张照片');
      return false;
    }
    console.log('window.udid', window.udid, window.appkey);
    save(this.options.voteName, {
      udid: window.udid,
      appkey: window.appkey,
      type: this.$route.query.type,
      company_name: this.companyName,
      legal_person: this.legalPerson,
      department: this.department,
      user_name: this.userName,
      contact_person: this.contactPerson,
      honors: this.honors,
      reasons: this.reasons,
      img_url_list: this.cover,
    }).then((res: any) => this.successSave(res));
  }
  successSave(res: any) {
    if (res.code === 101) {
      Toast.fail('信息填写不全！');
    } else if (res.code === 200) {
      Toast.success('提交成功，请等待审核！');
      this.noButton = false;
      setTimeout(() => {
        this.$router.push({
          path: 'Third',
        });
      }, 300);
    } else if (res.code === 203) {
      Toast.fail('请登录后再访问！');
    } else {
      Toast.fail(res.msg);
    }
  }
}
